import { useLingui } from '@lingui/react/macro'
import Link from 'next/link'

export const Help = () => {
	const { t } = useLingui()

	return (
		<ul className='flex flex-col'>
			<li className='mb-1 font-bold'>{t`À propos`}</li>

			<li>
				<Link
					href='/a-propos'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					{t`Qui sommes-nous ?`}
				</Link>
			</li>

			<li>
				<Link
					href='https://support.cocoon-space.com/'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					{t`FAQ`}
				</Link>
			</li>

			<li>
				<Link
					href='mailto:contact@cocoon-space.com'
					target='_blank'
					className='hover:text-primary text-sm'
				>
					{t`Nous contacter`}
				</Link>
			</li>
		</ul>
	)
}
